import { DialogActionsBar } from '@progress/kendo-react-dialogs';
import * as React from 'react';
import { useCallback } from 'react';
import Button from 'src/components/design-system/Button';
import Dialog from 'src/components/design-system/Dialog';
import useRedirect from 'src/hooks/useRedirect';
import { closePoAttachModal, closePoStatusModal } from 'src/sections/enter_receipt/GuideMeSteps';

interface IProps {
  openModal: boolean;
  closeModal: () => void;
  poId?: number;
  receiptId?: number;
}

const ClosePoWizard: React.FC<IProps> = ({ openModal, closeModal, poId, receiptId }) => {
  const { redirect, getUrl } = useRedirect();
  const handleRedirect = useCallback(() => {
    redirect(getUrl('receiptDetails')(String(receiptId), String(poId)));
    closeModal();
  }, [closeModal, getUrl, poId, receiptId, redirect]);

  return (
    <Dialog
      open={openModal}
      width="500px"
      onClose={closeModal}
      title={receiptId ? closePoAttachModal.title : closePoStatusModal.title}
      id="modal"
    >
      {receiptId ? closePoAttachModal.content : closePoStatusModal.content}
      <DialogActionsBar>
        <div className="flex justify-end gap-2">
          {receiptId && (
            <Button color="info" onClick={handleRedirect} className="capitalize">
              OK
            </Button>
          )}
          <Button color="info" onClick={closeModal}>
            {receiptId ? <span>Cancel</span> : <span>OK</span>}
          </Button>
        </div>
      </DialogActionsBar>
    </Dialog>
  );
};
export default ClosePoWizard;
